import { createContext, useContext } from 'react';

/** What every part of the page needs: translate, number/date text, the shows, the screens and the clock. */
export const SchCtx = createContext(null);
export const useSch = () => useContext(SchCtx);
